"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
require("core-js/modules/es.array.filter");
require("core-js/modules/es.array.map");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.min = exports.max = void 0;
var _get = _interopRequireDefault(require("lodash/get"));
var min = function min(config, product) {
  return Math.min.apply(Math, config.properties.map(function (key) {
    return (0, _get.default)(product, key);
  }).filter(function (v) {
    return Number.isFinite(v);
  }));
};
exports.min = min;
var max = function max(config, product) {
  return Math.max.apply(Math, config.properties.map(function (key) {
    return (0, _get.default)(product, key);
  }).filter(function (v) {
    return Number.isFinite(v);
  }));
};
exports.max = max;